// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"89ad681b","977":"21ff4432"}[chunkId] + ".chunk.js";
};